<template>
    <div class="modal fade" id="age-limit-to-bo">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">みんなのオプション</h4>
                </div>
                <div class="modal-body">
                    <p id="note" v-if="ageLimitMsg">{{ ageLimitMsg }}歳未満の方はオプション口座の開設はできません。</p>
                    <p v-if="!hasUserBirthDay">オプション口座の開設には登録情報の更新が必要です。以下連絡先までお電話ください。<br/>{{this.telephone}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";

    export default {
        name: "BoAgeLimitModal",
        data() {
            return {
                ageLimitMsg: "",
                hasUserBirthDay: true,
                telephone: ""
            }
        },
        mounted() {
            ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_BO_AGE_LIMIT_MSG, (params) => {
                if (params.hasBoAgeLimit || !params.hasUserBirthDay) {
                    this.updateAgeLimitMsg(params.hasBoAgeLimit, params.hasUserBirthDay);
                    this.telephone = params.telephone;
                    this.show();
                }
            });
        },
        methods: {
            updateAgeLimitMsg(ageLimit, hasUserBirthDay) {
                this.ageLimitMsg = ageLimit;
                this.hasUserBirthDay = hasUserBirthDay;
            },
            show() {
                $("#age-limit-to-bo").modal("show");
            },
            hide() {
                $("#age-limit-to-bo").modal("hide");
            }
        }
    }

</script>

<style scoped>
    .modal-dialog{
        max-width: 600px !important;
    }
</style>
